import { render, staticRenderFns } from "./ListItemBox.vue?vue&type=template&id=8610ae2e&scoped=true&lang=pug&"
import script from "./ListItemBox.vue?vue&type=script&lang=ts&"
export * from "./ListItemBox.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemBox.vue?vue&type=style&index=0&id=8610ae2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8610ae2e",
  null
  
)

export default component.exports